import "./application/app.ts";
import "./router/routerHooks";
import {
	spaNavigateUrl,
	epoqNavigateToUrl,
	eightSelectNavigateToUrl,
	lastOrchestratedNavigatedUrl,
	resetLastOrchestratorNavigatedUrl,
} from "./router/index";
import { isAppMounted } from "./router/utils";

__webpack_public_path__ = window.ocm.config.resourcesHostname + __webpack_public_path__;

// all exports are global after window.load event accessable (Orchestrator.navigateToUrl(event))
export {
	spaNavigateUrl,
	isAppMounted,
	epoqNavigateToUrl,
	eightSelectNavigateToUrl,
	lastOrchestratedNavigatedUrl,
	resetLastOrchestratorNavigatedUrl,
};
